module.exports = __webpack_public_path__ + "preview-eac7acfc/prompt-bold-7fdea824c0e8a36f26d5df9fd80fe5a3.ttf";